import React from "react";
import PropTypes from "prop-types";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import FormCheck from "react-bootstrap/FormCheck";
import api from "../services/api";

let timeRef;

class LogTail extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.logs = {};
    this.scroll_paused = false;
    for (let i = 0; i < props.logs.length; i += 1) {
      const logName = props.logs[i].log_name;
      this.logs[logName] = {};
      this.logs[logName].log_name = props.logs[i].log_name;
      this.logs[logName].log_unit = props.logs[i].log_unit;
      this.logs[logName].log_title = props.logs[i].log_title;
      this.logs[logName].started = false;
      this.logs[logName].last_line_no = 0;
      this.logs[logName].data = [];
    }

    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      loading: false,
      key: 0,
      autoScroll: true
    };
  }

  componentDidMount() {
    this.openLogs();
    timeRef = setTimeout(() => {
      this.updateLogs();
    }, 1000);
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  componentWillUnmount() {
    this.closeAllLogs();
    clearTimeout(timeRef);
  }

  handleSelect(key) {
    this.setState({ key });
  }

  openLogs = () => {
    Object.keys(this.logs).map(key => {
      const log = this.logs[key];
      api
        .startLogTail({ log_name: log.log_name, log_unit: log.log_unit })
        .then(response => {
          this.logs[response.data.log_name].started = true;
        });
      return log;
    });
  };

  togglePauseScrolling = () => {
    const { autoScroll } = this.state;
    this.scroll_paused = !this.scroll_paused;
    if (!this.scroll_paused) {
      this.scrollToBottom();
    }
    this.setState({ autoScroll: !autoScroll });
  };

  scrollToBottom = () => {
    if (this.scroll_paused) {
      return;
    }
    Object.keys(this.logs).map(key => {
      const log = this.logs[key];
      const e = document.getElementById(`id_${log.log_name}`);
      if (e != null) {
        e.scrollTop = e.scrollHeight;
      }
      return log;
    });
  };

  updateLogs = () => {
    if (!this.props.isPaused) {
      Object.keys(this.logs).map(key => {
        const log = this.logs[key];
        if (log.started) {
          const lastLineNo = log.last_line_no;
          const logName = log.log_name;
          api
            .logTail({ last_line_no: lastLineNo, log_name: logName })
            .then(response => {
              const d = response.data;
              if (
                d.return_code === 0 &&
                this.logs[logName].last_line_no !== d.last_line_no
              ) {
                this.logs[logName].last_line_no = d.last_line_no;
                this.logs[logName].data = this.logs[logName].data.concat(
                  d.data
                );
                this.forceUpdate();
              }
            })
            .catch(() => {
              // do nothing for now
            });
        }
        return log;
      });
    }
    timeRef = setTimeout(() => {
      this.updateLogs();
    }, 2000);
  };

  closeAllLogs = () => {
    Object.keys(this.logs).map(key => {
      const log = this.logs[key];
      api.stopLogTail({ log_name: log.log_name });
      return log;
    });
  };

  renderLogMessages = logName => {
    if (this.logs[logName].data != null) {
      return this.logs[logName].data.map((m, i) => <li key={i}>{m}</li>);
    } else {
      return "";
    }
  };

  renderTabs = () =>
    Object.keys(this.logs).map((logName, i) => (
      <Tab
        key={i}
        eventKey={i}
        title={this.logs[logName].log_title}
        onEnter={this.scrollToBottom}
      >
        <div id={`id_${logName}`} className="config-status__monitor">
          <ul>{this.renderLogMessages(logName)}</ul>
        </div>
        <div className="right">
          <FormCheck
            onChange={this.togglePauseScrolling}
            type="switch"
            label="Autoscroll"
            checked={this.state.autoScroll}
          />
        </div>
      </Tab>
    ));

  render() {
    return (
      <Tabs
        id="log-tail-tabs"
        variant="tabs"
        activeKey={this.state.key}
        onSelect={this.handleSelect}
        className="nav-tabs--sm"
      >
        {this.renderTabs()}
      </Tabs>
    );
  }
}

LogTail.propTypes = {
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      log_name: PropTypes.string,
      log_unit: PropTypes.string,
      log_title: PropTypes.string
    })
  ),
  isPaused: PropTypes.bool
};

LogTail.defaultProps = {
  isPaused: false
};

export default LogTail;
